module.exports = __webpack_public_path__ + "img/NoRecordingText.23fa0deb.svg";